import React, { useState } from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import media from "../../utils/mediaQueries"
import SideBarMenu from "./sidebarmenu"
import useToggle from "../../utils/hooks/useToggle"
import DarkModeToggle from "../darkModeToggle/darkmodetoggle"

import Logo from "../../images/MindMeLogo.svg"
const { se, desktop } = media

const SideBar = ({ toggleOpen }) => {
  const [isToggled, toggle] = useToggle(false)
  const handleExpandAll = () => toggle(true)

  return (
    <SideBarWrapper toggleOpen={toggleOpen}>
      <LogoPlaceholder>
        <Link to="/">
          <StyledImg src={Logo} alt="MindMe Logo" />
        </Link>
      </LogoPlaceholder>
      <SideBarNavWrapper>
        <SideBarNavContainer>
          <SideBarNavContainerInner>
            <Link to="/videos" style={{ textDecoration: "none" }}>
              <VideoLink>View Video Gallery →</VideoLink>
            </Link>
            <ButtonWrapper>
              <ExpandSideBarMenu onClick={handleExpandAll}>
                {isToggled ? "Reduce All" : "Expand All"}
              </ExpandSideBarMenu>
              <DarkModeToggle />
            </ButtonWrapper>
            <SideBarMenu expandAll={isToggled} toggleExpandAll={toggle} />
          </SideBarNavContainerInner>
        </SideBarNavContainer>
      </SideBarNavWrapper>
    </SideBarWrapper>
  )
}

export default SideBar

const SideBarWrapper = styled.aside`
  background-color: ${props => props.theme.sidebar};
  ${se &&
    se`
  padding: 30px 0 0 0;

  ${({ toggleOpen }) =>
    toggleOpen &&
    `
      flex-direction: column;
      position: absolute;
      top: 0;
      width: 100%;
      min-height: 100%;
      z-index: 90;
    `}

  display: ${props => (props.toggleOpen ? `flex` : `none`)};
`}
  ${desktop &&
    desktop`
    display: flex;
    flex-direction: column;
    position: absolute;
    width: 330px;
    height: 100%;
  `}
`

const LogoPlaceholder = styled.div`
  ${se &&
    se`
  margin-bottom: 30px;
`}
  ${desktop &&
    desktop`
    display: block;
    height: 30px;
    flex-grow: 0;
    flex-shrink: 0;
    margin-bottom: 0px;
  `}
`

const StyledImg = styled.img`
  margin-bottom: 0;
  ${se &&
    se`
   width: 40%;
   max-width: 200px;
  `}

  ${desktop &&
    desktop`
    display:none;
      
`}
`

const SideBarNavWrapper = styled.div`
  ${se &&
    se`
  padding-bottom: 30px; 
`}
  ${desktop &&
    desktop`
    flex-grow: 1;
    overflow-y: auto;
    width: inherit;
`}
`
const SideBarNavContainer = styled.div`
  ${desktop &&
    desktop`
    height: 100%;
`}
`

const SideBarNavContainerInner = styled.div`
  ${desktop &&
    desktop`
    padding: 30px 20px;
  `}
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
`

const ExpandSideBarMenu = styled.button`
  background: transparent;
  cursor: pointer;
  border: none;
  padding: 0;
  color: ${props => props.theme.text};
`

const VideoLink = styled.h4`
  margin-bottom: 20px;
  cursor: pointer;
  color: ${props => props.theme.text};
  text-decoration: none;
`
